import React, { useState, useContext } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import CustomTooltip from "utils/CustomTooltip";

export default function GoogleAdsCampaignFilters() {
  const context = useContext(SettingsContext);
  const [googleAdsCampaignFiltersEnabled, setGoogleAdsCampaignFiltersEnabled] = useState(context.googleAdsCampaignFiltersEnabled);
  const [googleAdsCampaignFilters, setGoogleAdsCampaignFilters] = useState(context.googleAdsCampaignFilters || []);

  // Combined state and context updates
  const setFiltersAndContext = (newFilters) => {
    setGoogleAdsCampaignFilters(newFilters);
    context.setGoogleAdsCampaignFilters(newFilters);
  };

  const handleCheckboxChange = (event) => {
    setGoogleAdsCampaignFiltersEnabled(event.target.checked);
    context.setGoogleAdsCampaignFiltersEnabled(event.target.checked);
  };

  const addCustomConversion = () => {
    const newConversion = { id: new Date().valueOf(), type: "exclusive", name: "" };
    const updatedFilters = [...googleAdsCampaignFilters, newConversion];
    setFiltersAndContext(updatedFilters);
  };

  const deleteCustomConversion = (index) => {
    const updatedFilters = googleAdsCampaignFilters.filter((_, i) => i !== index);
    setFiltersAndContext(updatedFilters);
  };

  const handleCustomConversionChange = (index, field, value) => {
    const updatedFilters = googleAdsCampaignFilters.map((campaign, i) => {
      if (i === index) {
        return { ...campaign, [field]: value };
      }
      return campaign;
    });
    setFiltersAndContext(updatedFilters);
  };

  return (
    <div className="google-ads-custom-conversions-inner">
      <div className="lite-checkbox-container">
        <input
          type="checkbox"
          className="lite-checkbox"
          id="google_ads_campaign_filters"
          name="google_ads_campaign_filters_enabled"
          onChange={handleCheckboxChange}
          checked={googleAdsCampaignFiltersEnabled}
        />
        <label htmlFor="google_ads_campaign_filters">
         Enable Campaign Filters
          <CustomTooltip
            faClass="far fa-question-circle pl-2"
            message="By default DataPulse will pull all campaigns from Google Ads. If you would like to include or exclude specific campaign terms, enable this option and add rules below."
            inline={true}
          />
        </label>
      </div>
      {googleAdsCampaignFiltersEnabled && (
        <div className="meta-ads-custom-conversions-inner">
          <div className="custom-conversions-container">
            {googleAdsCampaignFilters.map((campaignFilter, index) => (
              <div key={campaignFilter.id} className="google-ads-custom-conversion">
              <div className="select-wrapper">
                <select value={campaignFilter.type} onChange={(e) => handleCustomConversionChange(index, "type", e.target.value)}>
                  <option value="inclusive">Include</option>
                  <option value="exclusive">Exclude</option>
                </select>
              </div>
                <input
                  name={`google_ads_campaign_filters[${index}][name]`}
                  type="text"
                  placeholder="Campaign to exclude"
                  value={campaignFilter.name}
                  onChange={(e) => handleCustomConversionChange(index, "name", e.target.value)}
                />
                <button className="lite-btn btn-secondary" type="button" onClick={() => deleteCustomConversion(index)}>
                  Delete
                </button>
              </div>
            ))}
            <button className="lite-btn btn-primary" type="button" onClick={addCustomConversion}>
              Add Campaign Filter
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
